import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _SVGIconWithSizes;

import { createSvg } from "../createSvg";
import { IconSize, SVGIconWithSizes } from "../interfaces";
export default createSvg('IconMenu', new SVGIconWithSizes((_SVGIconWithSizes = {}, _defineProperty(_SVGIconWithSizes, IconSize.ExtraSmall, {
  paths: ['M0.888889 4H15.1111C15.6444 4 16 3.6 16 3C16 2.4 15.6444 2 15.1111 2H0.888889C0.355556 2 0 2.4 0 3C0 3.6 0.355556 4 0.888889 4ZM15.1111 12H0.888889C0.355556 12 0 12.4 0 13C0 13.6 0.355556 14 0.888889 14H15.1111C15.6444 14 16 13.6 16 13C16 12.4 15.6444 12 15.1111 12ZM0.888889 7H15.1111C15.6444 7 16 7.4 16 8C16 8.6 15.6444 9 15.1111 9H0.888889C0.355556 9 0 8.6 0 8C0 7.4 0.355556 7 0.888889 7Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), _defineProperty(_SVGIconWithSizes, IconSize.Small, {
  paths: ['M2 5H18C18.6 5 19 4.6 19 4C19 3.4 18.6 3 18 3H2C1.4 3 1 3.4 1 4C1 4.6 1.4 5 2 5ZM18 15H2C1.4 15 1 15.4 1 16C1 16.6 1.4 17 2 17H18C18.6 17 19 16.6 19 16C19 15.4 18.6 15 18 15ZM2 9H18C18.6 9 19 9.4 19 10C19 10.6 18.6 11 18 11H2C1.4 11 1 10.6 1 10C1 9.4 1.4 9 2 9Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), _defineProperty(_SVGIconWithSizes, IconSize.Medium, {
  paths: ['M2.40001 6H21.6C22.32 6 22.8 5.52 22.8 4.8C22.8 4.08 22.32 3.6 21.6 3.6H2.40001C1.68001 3.6 1.20001 4.08 1.20001 4.8C1.20001 5.52 1.68001 6 2.40001 6ZM21.6 18H2.40001C1.68001 18 1.20001 18.48 1.20001 19.2C1.20001 19.92 1.68001 20.4 2.40001 20.4H21.6C22.32 20.4 22.8 19.92 22.8 19.2C22.8 18.48 22.32 18 21.6 18ZM2.40001 10.8H21.6C22.32 10.8 22.8 11.28 22.8 12C22.8 12.72 22.32 13.2 21.6 13.2H2.40001C1.68001 13.2 1.20001 12.72 1.20001 12C1.20001 11.28 1.68001 10.8 2.40001 10.8Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), _defineProperty(_SVGIconWithSizes, IconSize.Large, {
  paths: ['M3.19998 8H28.8C29.76 8 30.4 7.36 30.4 6.4C30.4 5.44 29.76 4.8 28.8 4.8H3.19998C2.23998 4.8 1.59998 5.44 1.59998 6.4C1.59998 7.36 2.23998 8 3.19998 8ZM28.8 24H3.19998C2.23998 24 1.59998 24.64 1.59998 25.6C1.59998 26.56 2.23998 27.2 3.19998 27.2H28.8C29.76 27.2 30.4 26.56 30.4 25.6C30.4 24.64 29.76 24 28.8 24ZM3.19998 14.4H28.8C29.76 14.4 30.4 15.04 30.4 16C30.4 16.96 29.76 17.6 28.8 17.6H3.19998C2.23998 17.6 1.59998 16.96 1.59998 16C1.59998 15.04 2.23998 14.4 3.19998 14.4Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));